window.addEventListener("load", function () {
  const videos = document.querySelectorAll(".more-video-internal");
  videos.forEach((video) => {
    video.addEventListener("click", function handleClick(e) {
      e.preventDefault();
      //Play type is modal
      if (video.classList.contains("video-modal-trigger")) {
        // Grab everything needed for the modal
        let currentVideo = e.currentTarget;
        let modal = currentVideo.querySelector(".video-modal");
        let modalClose = currentVideo.querySelector(".video-close");
        let topLayer = currentVideo.querySelector(".top-layer");
        let videoElement = currentVideo.querySelector("video");

        // If the modal is not already open, open it
        if (!modal.classList.contains("video-modal-visible")) {
          modal.classList.add("video-modal-visible");
          topLayer.classList.add("hidden");
        } else {
          //close modal
          modal.classList.remove("video-modal-visible");
          topLayer.classList.remove("hidden");
          if (videoElement) {
            videoElement.pause(); // Pause the video
          }
        }
        document.addEventListener("keydown", function (event) {
          if (
            event.key === "Escape" &&
            modal.classList.contains("video-modal-visible")
          ) {
            modal.classList.remove("video-modal-visible");
            topLayer.classList.remove("hidden");
            if (videoElement) {
              videoElement.pause(); // Pause the video
            }
          }
        });
      } else {
        // Play type is click to play
        let currentVideo = e.currentTarget;
        let videoElement = currentVideo.querySelector("video");
        let videoPoster = currentVideo.querySelector(".video-poster");
        let playIcon = currentVideo.querySelector(".play-btn");
        let lightboxClose = document.querySelector(".lightbox-close");
        let swiperChange = document.querySelectorAll(".swiper-button");

        playIcon.addEventListener("click", function () {
          videoElement.play();
          playIcon.style.display = "none";
          videoElement.style.cursor = "pointer";
          if (videoPoster) {
            videoPoster.style.display = "none";
          }
        });

        videoElement.addEventListener("click", function () {
          videoElement.pause();
          playIcon.style.display = "flex";
          videoElement.style.cursor = "default";
          if (videoPoster) {
            videoPoster.style.display = "block";
          }
        });

        // if (videoElement.paused) {
        //   videoElement.play();
        //   playIcon.style.display = "none";
        //   // videoPoster.style.display = "none";
        // } else {
        //   videoElement.pause();
        //   playIcon.style.display = "block";
        //   // videoPoster.style.display = "block";
        // }

        if (lightboxClose) {
          lightboxClose.addEventListener("click", function () {
            videoElement.pause();
            playIcon.style.display = "block";
            // videoPoster.style.display = "block";
          });
        }
        if (swiperChange) {
          swiperChange.forEach((button) => {
            button.addEventListener("click", function () {
              videoElement.pause();
              playIcon.style.display = "block";
              // videoPoster.style.display = "block";
            });
          });
        }
      }
    });
    // Ensure video autoplays correctly and only plays when visible
    if (video.classList.contains("autoplay")) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              video.play();
            } else {
              video.pause();
            }
          });
        },
        // How much of the video should be visible before playing/pausing
        { threshold: 0.5 }
      );
      observer.observe(video);
    }
  });
  // Bug fix to ensure videos play on actual click. On load it requires 2 clicks to work the first time,
  // so this takes out that additional click.
  videos.forEach((video) => {
    video.click();
  });
});
